import React from 'react'
import PropTypes from 'prop-types'
import { TablePagination } from '../mui/Core/index'

function GenericTablePagination({ count, page, rowsPerPage, onPageChange, onRowsPerPageChange }) {
  return (
    <TablePagination
      rowsPerPageOptions={[25, 50]}
      component='div'
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      showFirstButton
      showLastButton
      labelpagesize='Rows per page'
      labelDisplayedRows={(pages) =>
        `${pages.from.toLocaleString()} - ${pages.to.toLocaleString()} of ${pages.count.toLocaleString()}`
      }
    />
  )
}

GenericTablePagination.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
}
export default GenericTablePagination
